<template>
  <v-text-field
    v-bind="$attrs"
    v-model="text_value"
    ref="input"
    @input="onInput"
    @focus="onFocus"
    @blur="onBlur"
  ></v-text-field>
</template>
<script setup>
import { ref, watch } from 'vue';

const props = defineProps(
  {
    modelValue: {
      type: [String, Number],
      default: '',
    },
    upper: {
      type: Boolean,
      default: false,
    },
    lower: {
      type: Boolean,
      default: false,
    },
    capitalized: {
      type: Boolean,
      default: false,
    },
    select: {
      type: Boolean,
      default: false,
    },
  }
);
const emit = defineEmits(['update:modelValue']);

const text_value = ref(null);
const input = ref(null);

function onInput(event) {
  if (props.upper || props.lower) {
    let posicao = event.target.selectionStart; // Marca a posição do cursor
    event.target.value = transforma(event.target.value);
    event.target.setSelectionRange(posicao, posicao); // Restaura a posição do cursor
  }
  emit('update:modelValue', event.target.value);
}

function onFocus(event) {
  if (props.select) {
    setTimeout(function () {
      event.target.select();
    }, 0);
  }
}

function onBlur(event) {
  if (props.capitalized && !props.lower && !props.upper) {
    emit('update:modelValue', capitalize(event.target.value));
  }
}

function transforma(texto = '') {
  if (props.upper) {
    return texto.toUpperCase();
  }

  if (props.lower) {
    return texto.toLowerCase();
  }

  return texto;
}

function capitalize(texto) {
  const regex = /^(?=.*[áéíóúâêîôûàèìòùãõàèìòùäëïöü])/;
  let capitalized = texto
    .trim()
    .toLowerCase()
    .split(' ')
    .map((word) => {
      if (['da', 'das', 'de', 'do', 'dos'].includes(word)) {
        return word;
      }
      if (word.length == 1 && regex.test(word)) {
        return word;
      }
      return word.charAt(0).toUpperCase() + word.slice(1, word.length);
    });

  return capitalized.join(' ');
}

watch(() => props.modelValue, (value) => {
    text_value.value = value;
  },
  { immediate: true }
)
</script>


<style scoped>
</style>
